import { ArrowRightIcon } from 'lucide-react';
import { backyardLinks, images } from '../data/site';
import { SiteLink } from './SiteLink';
export function BackyardLiving() {
  return <section aria-labelledby="backyard-heading" className="w-full bg-white" data-id="element-11" data-mp="37zz3q5n8f1pk">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8 lg:py-16" data-id="element-12" data-mp="3msizumbys8xi">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-13" data-mp="3hz6ohdwapymp">
          <div className="lg:col-span-7" data-id="element-14" data-mp="3vquzteyq0j2m">
            <div className="aspect-[3/2] w-full overflow-hidden rounded-card" data-id="element-15" data-mp="3vtpl18pk67x3">
              <img src={images.backyardLiving} alt="Outdoor dining table and chairs under an umbrella beside a charcoal grill on a lawn sloping to a Michigan lake" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-16" data-mp="3rphtz4vmofvp" />
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-17" data-mp="26d7y3h38hlls">
            <p className="text-[14px] font-bold uppercase text-ember" data-id="element-18" data-mp="26ej3tmg8p3fj">Backyard Living</p>
            <h2 id="backyard-heading" className="mt-2 text-h2-mobile font-semibold text-ink lg:text-h2-desktop" data-id="element-19" data-mp="3s66mltqvdwmm">
              Outdoor Living Starts Here.
            </h2>
            <p className="mt-4 text-body text-ink/80 sm:text-body-lg" data-id="element-20" data-mp="4ymhi1ela7gt">
              Whether you're enjoying a quiet morning with coffee by the lake, grilling for family
              and friends, hosting your son's baseball team or relaxing in the hot tub after a long
              day, the right outdoor furniture transforms your backyard into your favorite place to
              be.
            </p>
            <p className="mt-4 text-[16px] font-bold text-ink" data-id="element-21" data-mp="oooi9wab37qy">
              Featured furniture lines: POLYWOOD and Winston
            </p>

            <ul className="mt-5 border-t border-ink/10" data-id="element-22" data-mp="2qfrqkewq4a8c">
              {backyardLinks.map(link => <li key={link.label} className="border-b border-ink/10" data-id="element-23" data-mp="2ugbqtrclftyp">
                  <SiteLink to={link.href} className="flex min-h-[52px] items-center justify-between gap-3 text-[16.5px] font-medium text-ink transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-24" data-mp="1md4q619mvjy">
                    {link.label}
                    <ArrowRightIcon className="h-4 w-4 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-25" data-mp="6lheaxs3qvat" />
                  </SiteLink>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}